'use strict';

import Api from "./Api";

export default class History extends Api {

    static getList(targetId, tables, page = 1, perPage = 10, sort = undefined, extraFields = []) {
        const url = this.url + 'history/list';

        return this.getAxios().get(url, {
            params: {
                target_id: targetId,
                tables: tables,
                page: page,
                'per-page': perPage,
                sort: sort,
                expand: extraFields.join(','),
            },
        });
    }

}
